import React, { useEffect, useMemo, useState } from 'react';
import { IconUngroup } from '@bynder/icons';
import generateTestId from '~/helpers/testIdHelpers';
import useEditor from '../../../../../hooks/useEditor';
import { collectTopLevelGroups } from './utils';
import useElementGeneralActions from 'packages/pages/editor/useElementGeneralActions';
import useGeneralShortcuts from 'packages/hooks/shortcuts/useGeneralShortcuts';
import { TimelineActionsIcon } from '../TimelineActions.styled';
import { parseShortcutForTooltip } from 'packages/common/WithShortcutLabel';

export default function UngroupAction() {
    const { manipulationRenderer } = useEditor();
    const [selectedGroups, setSelectedGroups] = useState(() =>
        collectTopLevelGroups(manipulationRenderer?.getSelectedElements() || []),
    );
    const isActive = !!selectedGroups.length;

    const { handleUnGroup } = useElementGeneralActions(setSelectedGroups, selectedGroups);

    useGeneralShortcuts({ handleUnGroup });

    const testId = useMemo(() => generateTestId('timeline_actions_ungroup'), []);

    useEffect(() => {
        if (!manipulationRenderer) {
            return;
        }

        const listener = () => {
            setSelectedGroups(collectTopLevelGroups(manipulationRenderer.getSelectedElements()));
        };

        manipulationRenderer.eventEmitter.on('elementSelected', listener);

        return () => {
            manipulationRenderer.eventEmitter.off('elementSelected', listener);
        };
    }, [manipulationRenderer]);

    return (
        <div title={`Ungroup (${parseShortcutForTooltip(['Shift', 'cmd', 'g'])})`}>
            <TimelineActionsIcon onClick={handleUnGroup} active={isActive} {...testId}>
                <IconUngroup />
            </TimelineActionsIcon>
        </div>
    );
}
